import { type DriveFile } from '@/shared/DriveTypes';
import { Home } from '@mui/icons-material';
import { match, P } from 'ts-pattern';
import * as appStyles from '~/app.css';
import { useTheme } from '~/utils/store';
import { Logo } from '../WikiSelector/WikiSelector';
import * as styles from './Tree.css';

export const HomeIcon = ({ wiki }: { wiki: DriveFile }) => {
  const theme = useTheme();
  const { fontColor } = wiki.properties ?? {};
  return (
    <>
      {match({
        logoId: wiki.properties?.logoId,
        unicode: wiki.properties?.unicode,
      })
        .with({ logoId: P.string }, ({ logoId }) => (
          <Logo
            alt="Wiki logo"
            className={styles.homeLogo}
            src={`https://lh3.googleusercontent.com/d/${logoId}=w${34 * window.devicePixelRatio}`}
            wiki={wiki}
          />
        ))
        .with({ unicode: P.string }, ({ unicode }) => <div style={{ lineHeight: 0, fontSize: 18 }}>{unicode}</div>)
        .otherwise(() => (
          <Home
            className={appStyles.fadeIn}
            htmlColor={(theme === 'light' ? fontColor : undefined) ?? '#fff'}
            style={{
              fontSize: 22,
              position: 'relative',
              left: -3.5,
              opacity: 0.9,
            }}
          />
        ))}
    </>
  );
};
